import { createStore } from 'vuex'
import { Payload, State } from './store.types';

export default createStore({
    state: {
        labels: [],
        form: {
            redenContact: undefined,
            vraag: '',
            gegevens: {
                persoonsGegevens: {
                    voorletters: undefined,
                    achternaam: undefined,
                },
                bsn: undefined,
                adresGegevens: {
                    straat: undefined,
                    postcode: undefined,
                    plaats: undefined,
                    land: 'nl',
                    adresbuitenland: undefined
                },
                contactGegevens: {
                    emailAdres: undefined,
                    telefoonnummer: undefined
                }
            },
            captcha: undefined
        },
        contactredenen: [],
        toonCaptchaInfo: true
    } as State,
    mutations: {
        setReden(state, payload) {
            state.form.redenContact = payload
        },
        setVraag(state, payload) {
            state.form.vraag = payload
        },
        setLabels(state, payload) {
            state.labels = payload
        },
        setPersoonsGegevens(state, payload: Payload) {
            state.form.gegevens.persoonsGegevens[payload.type] = payload.value
        },
        setBsn(state, payload) {
            state.form.gegevens.bsn = parseInt(payload)
        },
        setAdresGegevens(state, payload: Payload) {
            state.form.gegevens.adresGegevens[payload.type] = payload.value
        },
        setContactGegevens(state, payload: Payload) {
            state.form.gegevens.contactGegevens[payload.type] = payload.value
        },
        setCaptcha(state, payload) {
            state.form.captcha = payload
        },
        setContactredenen(state, payload) {
            state.contactredenen = payload
        }
    },
    actions: {
        axiosSetContactredenen ({commit}, payload) {
            commit('setContactredenen', payload)
        },
        axiosLaadLabels({commit}, payload) {
         commit('setLabels', payload)
        }
     },
    getters: {
        form: state => (state.form ? state.form : {}),
        redenContact: state => (state.form.redenContact ? state.form.redenContact : {}),
        vraag: state => (state.form.vraag ? state.form.vraag : ''),
        persoonsGegevens: state => (state.form.gegevens.persoonsGegevens ? state.form.gegevens.persoonsGegevens : {}),
        achternaam: state => (state.form.gegevens.persoonsGegevens.achternaam ? state.form.gegevens.persoonsGegevens.achternaam : ''),
        bsn: state => (state.form.gegevens.bsn ? state.form.gegevens.bsn : undefined),
        adresGegevens: state => (state.form.gegevens.adresGegevens ? state.form.gegevens.adresGegevens : {}),
        contactGegevens: state => (state.form.gegevens.contactGegevens ? state.form.gegevens.contactGegevens : {}),
        captcha: state => (state.form.captcha ? state.form.captcha : ''),
        contactredenen: state => (state.contactredenen ? state.contactredenen : []),
        toonCaptchaInfo: state => (state.toonCaptchaInfo ? state.toonCaptchaInfo : true),
        veldopties: function (state) {
            if (state.contactredenen && state.form.redenContact) {
                const x = state.contactredenen.filter(reden => {
                    return reden.name === state.form.redenContact;
                });
                return x[0].veldOpties[0];
            } else {
                return [];
            }
        },
        redenContactItem: function (state) {
          if (state.contactredenen && state.form.redenContact) {
              const x = state.contactredenen.filter(reden => {
                  return reden.name === state.form.redenContact;
              });
              return x[0];
          }  else {
              return [];
          }
        },
        labels: state => ( (state.labels) ? state.labels : {}),
        sendMail: function (state) {
            return {
                captcha: state.form.captcha,
                reden: state.form.redenContact,
                vraag: state.form.vraag,
                voorletters: state.form.gegevens.persoonsGegevens.voorletters,
                achternaam: state.form.gegevens.persoonsGegevens.achternaam,
                bsn: String(state.form.gegevens.bsn),
                straat: state.form.gegevens.adresGegevens.land !== 'nl' ? "Buitenlands adres: " + state.form.gegevens.adresGegevens.adresbuitenland : state.form.gegevens.adresGegevens.straat,
                pcode: state.form.gegevens.adresGegevens.land !== 'nl' ? "" : state.form.gegevens.adresGegevens.postcode,
                plaats: state.form.gegevens.adresGegevens.land !== 'nl' ? "" : state.form.gegevens.adresGegevens.plaats,
                emailadres: state.form.gegevens.contactGegevens.emailAdres,
                telefoon: state.form.gegevens.contactGegevens.telefoonnummer
            }
        },
        roepnaam: function(state) {
            return state.form.gegevens.persoonsGegevens.voorletters +' '+ state.form.gegevens.persoonsGegevens.achternaam;
        }
    }
})
